module.exports = __webpack_public_path__ + "img/gear_brown.5e8e1a2b.svg";